import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_vd_step extends Component {
    constructor(props) {
        super(props);
        //this.chartRef = React.createRef();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        //const myChartRef = this.chartRef.current.getContext("2d");
        var ctx = document.getElementById('Chart_vd_step').getContext('2d');
        const data = this.props.data[3]['value'];
        const date = this.props.date;
        var x_data = [];
        var y_data = [];
        for (var i = 0; i < data.length; i++) {
            x_data.push(data[i]['sum']);
            var tmp = format(new Date(data[i]['time']), "yyyy/MM/dd");
            y_data.push(tmp);
        }
        console.log(x_data);
        console.log(y_data);
        var isstepped = false;
        if (window.Chart_vd_step instanceof Chart) window.Chart_vd_step.destroy();
        window.Chart_vd_step = new Chart(ctx, {
            type: "bar",
            // plugins: [ChartDataLabels],
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Steps',
                        data: x_data,
                        // steppedLine: isstepped,
                        backgroundColor: '#ae3450',
                        // borderColor:'rgba(101, 198, 240, 1)',
                        // fill:false,
                        datalabels: {
                            // anchor: 'end',
                            // align: 'top',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        offset: true,
                        time: {
                            unit: 'day'
                        }
                    }],
                },
                title: {
                    display: true,
                    text: "Steps",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_vd_step"></canvas>
            </div>
        );
    }
}